import Navbar from '../components/Navbar';
import VolverAlPanel from '../components/VolverAlPanel';

function Configuraciones() {
  const usuario = JSON.parse(localStorage.getItem('usuario'));
  return (
    <>
      <Navbar nombre={usuario.nombre_completo} rol={usuario.rol} />
      <VolverAlPanel />
      <div style={{ padding: '2rem' }}>
        <h2>⚙️ Configuraciones</h2>
        <p>Aquí podrás configurar sensores, límites, alertas, etc.</p>
      </div>
    </>
  );
}

export default Configuraciones;
